import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PromptElement from "../../PromptElement";
import ListDataTermsAndCondition from "./ListDataTermsAndCondition";
import AddEditFormTermsAndCondition from "./AddEditFormTermsAndCondition";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { getTermsData } from "../../../../store/Api";

export default function TermsAndCondition(props) {
  const navigate = useNavigate();
  const termsData = useSelector((state) => state.termsData);
  const token = localStorage.getItem("token");
  
  useEffect(() => {
   dispatch(getTermsData(token));
  },[])
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      if(!checkAccess("Terms And Condition", "terms-and-conditions-create")){
        setAddOrEdit({});
        navigate('/dashboard/roles-and-permission')
      }else{
        setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
      }
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [particulars, setParticulars] = useState("");
  const [remarks, setRemarks] = useState("");
  const [preParticulars, setPreParticulars] = useState("");
  const [preRemarks, setPreRemarks] = useState("");

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        particulars,
        remarks,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/terms-and-condition`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        if(particulars===preParticulars && remarks===preRemarks) 
        {
          setSubmitFormLoading(false)
          return dispatch(setAppError({msg:'No changes made.'}))
        }
        response = await axios.put(
          `/dashboard/terms-and-condition/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        dispatch(getTermsData(token))
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
         navigate("/dashboard/terms-and-condition");
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "termsAndCondition");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/terms-and-condition");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id,data) => {
    navigate(`/dashboard/terms-and-condition/edit/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve) => setTimeout(resolve, 300));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setParticulars(data.particulars);
        setRemarks(data.remarks);
        setPreParticulars(data.particulars);
        setPreRemarks(data.remarks);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(
          `/dashboard/terms-and-condition/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(getTermsData(token))
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(setAppError({msg: err.message}));
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({msg: err?.response?.data.message,})
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setRemarks("");
    setParticulars("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>  checkAccessFn(dashboardData, module, name);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            {checkAccess("Terms And Condition", "terms-and-conditions-create") &&
              <Link to="/dashboard/terms-and-condition/create">
                <button
                  className="p-2 bg-red uppercase text-white rounded-md"
                  onClick={addData}
                >
                  Add New Terms +
                </button>
              </Link>
          }

            <ListDataTermsAndCondition
              list={termsData}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              column={4}
              titles={["SL No.", "Particulars", "Remarks", "Action"]}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditFormTermsAndCondition
            form={[
              {
                type: "text",
                text: "Particulars",
                name: "particulars",
                value: particulars,
                update: setParticulars,
                columnName: "particulars",
              },
              {
                type: "textarea",
                text: "Remarks",
                name: "remarks",
                value: remarks,
                update: setRemarks,
                columnName: "remarks",
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues ? true : false}
          />
        )}
      </div>
    </>
  );
}